<div class="Search uk-height-1-1" [ngClass]="'Search--' + searchStyle" [class.Search--open]="formIsOpen">
    <form class="Search_Form uk-height-1-1"	action="#" method="post" #searchForm="ngForm">
        <div class="Search_Filter uk-hidden" [class.uk-hidden]="!(filter.activeTargetAudience || filter.activeActivity)">
            <div class="uk-flex uk-flex-middle">
				<span class="IconItem IconItem--filter">
					<img src="/assets/img/icon/filter.svg" uk-svg>
				</span>
                <div class="uk-display-inline-block">
					<span class="Search_Filter_Who" [class.uk-hidden]="!filter.activeTargetAudience">
						<span class="Search_Filter_Name">{{filter.activeTargetAudience ? filter.activeTargetAudience.name : ''}}</span>
						<span class="IconItem IconItem--close" (click)="filter.clearFilter('target')">
							<img src="/assets/img/icon/close.svg" uk-svg>
						</span>
					</span>
					<span class="Search_Filter_Where" [class.uk-hidden]="!filter.activeActivity">
						<span class="Search_Filter_Name">{{filter.activeActivity ? filter.activeActivity.name : ''}}</span>
	                    <span class="IconItem IconItem--close" (click)="filter.clearFilter('activity')">
							<img src="/assets/img/icon/close.svg" uk-svg>
						</span>
                    </span>
                </div>
            </div>
        </div>
        <div class="Search_Crumbs">
            <ul *ngIf="breadCrumbsService.crumbs.length > 0" class="uk-breadcrumb" itemscope="" itemtype="http://schema.org/BreadcrumbList">
                <li *ngFor="let crumb of breadCrumbsService.crumbs;let indexOfelement=index;" itemscope="" itemprop="itemListElement" itemtype="http://schema.org/ListItem">
					<a *ngIf="crumb.href" [class]="crumbStyle === 'none' ? '' : crumb.color + (crumbStyle === 'background' ? '-bg-a' : '-color')"
						[routerLink]="crumb.href" itemprop="item">
						{{crumb.name}}
						<meta itemprop="name" content="{{crumb.name}}">
					</a>
					<span *ngIf="!crumb.href" [class]="crumbStyle === 'none' ? '' : crumb.color + (crumbStyle === 'background' ? '-bg-a' : '-color')" itemprop="item">
						{{crumb.name}}
						<meta itemprop="name" content="{{crumb.name}}">
					</span>
					<meta itemprop="position" content="{{indexOfelement + 1}}">
				</li>
            </ul>
        </div>
		<input class="Search_Form_Input uk-input" type="text" name="search"
			placeholder="Поиск в Магазине"
			[id]="id + '_input'"
			[(ngModel)]="searchPhrase"
			(ngModelChange)="triggerSearch()"
			(blur)="closeFastSearch()"
		>
		<button class="Search_Form_Close" type="button" (click)="clearForm()">
			<span class="IconItem IconItem--close">
				<img src="/assets/img/icon/close.svg" uk-svg>
			</span>
		</button>
	</form>

	<label class="Search_Form_Label uk-height-1-1" [for]="id + '_input'" (click)="openForm()">
		<span class="IconItem IconItem--search">
			<img src="/assets/img/icon/search.svg" uk-svg>
		</span>
	</label>

    <div class="FastSearch" [class.uk-hidden]="!fastSearchOpen">
        <div *ngIf="placeholder">
            <div class="uk-grid-collapse" uk-grid="uk-grid">
                <div class="FastSearch_LeftCol uk-text-right uk-width-1-3@m">
					<span class="FastSearch_LeftCol_Section Placeloader">Demo service</span>
				</div>
                <div class="FastSearch_RightCol uk-width-2-3@m">
                    <div class="FastSearch_RightCol_Result">
                        <p class="uk-margin-remove-bottom Placeloader">Lorem ipsum dolor sit amet.</p>
						<ul class="uk-breadcrumb">
							<li><a class="Placeloader">Home</a></li>
							<li><a class="Placeloader">Service</a></li>
							<li><a class="Placeloader">Test</a></li>
						</ul>
                    </div>
                </div>
            </div>
            <div class="uk-grid-collapse" uk-grid="uk-grid">
                <div class="FastSearch_LeftCol uk-text-right uk-width-1-3@m">
					<span class="FastSearch_LeftCol_Section Placeloader">Demo service</span>
				</div>
                <div class="FastSearch_RightCol uk-width-2-3@m">
                    <div class="FastSearch_RightCol_Result">
                        <p class="uk-margin-remove-bottom Placeloader">Lorem ipsum dolor sit amet.</p>
                        <p class="uk-margin-remove Placeloader">Lorem ipsum dolor sit amet.</p>
						<ul class="uk-breadcrumb">
							<li><a class="Placeloader">Home</a></li>
							<li><a class="Placeloader">Service</a></li>
						</ul>
                    </div>
                </div>
            </div>
        </div>

        <div *ngIf="results.length === 0" class="uk-text-center">Безрезультатно</div>

        <div class="uk-grid-collapse uk-grid" *ngIf="results.length > 0">
            <!-- <div class="FastSearch_LeftCol uk-text-right uk-width-1-4@m">
				<span class="FastSearch_LeftCol_Icon">
					<span class="IconItem uk-text-primary">
						<img src="/assets/img/icon/case.svg" uk-svg>
					</span>
				</span>
				<span class="FastSearch_LeftCol_Section">Магазин</span>
			</div> -->
            <div class="FastSearch_RightCol uk-width-1-1">
                <div class="FastSearch_RightCol_Result" *ngFor="let item of results">
                    <p class="uk-margin-remove-bottom">
						<a class="FastSearch_Title" [routerLink]="item.ITEM_ID.startsWith('S') ? ['/catalog/section/', item.ITEM_ID.substr(1)] : ['/catalog', item.ITEM_ID]"
							[innerHtml]="item.TITLE_FORMATED"
						></a>
					</p>
                    <ul *ngIf="item.CRUMBS" class="uk-breadcrumb">
                        <li *ngFor="let crumb of item.CRUMBS">
							<a [class]="crumb.color + '-bg-a'" [routerLink]="crumb.href">{{crumb.name}}</a>
						</li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="uk-grid-collapse" uk-grid *ngIf="results.length > 0">
			<a class="uk-button uk-button-text uk-margin-top uk-margin-auto-left uk-margin-auto-right"
				[routerLink]="['/search']" [queryParams]="{q: searchPhrase}"
			>Больше результатов поиска</a>
		</div>
	</div>
</div>
